
<!-- <p><uni-button label="Abrir visor PDF" color="success" (click)="clickOpenViewerPDF()"></uni-button></p> -->

<div class="order-table order-table--minimal">
    <div class="order-table__header">
        <div class="order-table__row">
            <div class="order-table__cell">
                Fecha
            </div>
            <div class="order-table__cell">
                Nº factura
            </div>
            <div class="order-table__cell order-table__cell--show-lg order-table__cell--2-0">
                concepto
            </div>
            <div class="order-table__cell order-table__cell--show-lg">
                Nº pedido
            </div>
            <div class="order-table__cell">
                Estado
            </div>
            <div class="order-table__cell order-table__cell--show-lg">
                Fecha vencimiento
            </div>
            <div class="order-table__cell order-table__cell--center">
                Importe
            </div>
            <div class="order-table__cell order-table__cell--show-lg order-table__cell--center">
                opciones
            </div>
        </div>
    </div>

    <div class="order-table__body">

        <div class="order-table__row" (click)="clickOpenViewerPDF()">
            <div class="order-table__cell">
                <p class="order-table__cell-title">Fecha:</p>
                <div class="order-table__cell-content">
                    20/10/2017
                </div>
            </div>
            <div class="order-table__cell">
                <p class="order-table__cell-title">Nº factura:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">
                        <strong>F17-182</strong>
                    </p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg order-table__cell--2-0">
                <p class="order-table__cell-title">concepto:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg">
                <p class="order-table__cell-title">Nº pedido:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">
                        <strong>17-805</strong>
                    </p>
                    <p class="order-table__text">
                        IR17082798
                    </p>
                </div>
            </div>
            <div class="order-table__cell">
                <p class="order-table__cell-title">Estado:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text order-table__text--pending">Pendiente</p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg">
                <p class="order-table__cell-title">Fecha vencimiento:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">
                        24/08/2017
                    </p>
                </div>
            </div>
            <div class="order-table__cell  order-table__cell--center">
                <p class="order-table__cell-title">Importe:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text order-table__text--big">
                        <strong>1.450 &euro;</strong>
                    </p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg order-table__cell--center">
                <p class="order-table__cell-title">Opciones:</p>
                <div class="order-table__cell-content">
                    <a href="#" class="order-table__text order-table__text--inline order-table__text--icon">
                        <svg width="16" height="18" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd">
                                <rect stroke="#6C6E79" x=".5" y=".5" width="14.8" height="16.9" rx="3" />
                                <path d="M12.838 10.023c.071.07.137.17.148.253.035.277.009.548-.122.745a.521.521 0 0 1-.305.207 1.22 1.22 0 0 1-.306.034c-.674 0-1.742-.34-2.61-.827a23.17 23.17 0 0 0-3.58.85c-.988 1.723-1.706 2.493-2.324 2.493a.742.742 0 0 1-.335-.08l-.246-.125c-.154-.088-.177-.278-.146-.427.095-.466.67-1.054 1.538-1.572.102-.062.539-.292.557-.302l.255-.135c.246-.42.518-.918.818-1.504l.037-.073c.285-.557.607-1.19.865-1.817l.092-.223c-.36-1.374-.558-2.434-.366-3.143.064-.226.305-.377.605-.377l.155.005c.266-.011.435.2.521.398l.028.07c.022.066.03.09.041.174.084.608-.233 2.41-.233 2.41a7.513 7.513 0 0 1-.05.207c.292.803.762 1.532 1.326 2.058.21.195.476.358.735.507a10.93 10.93 0 0 1 1.584-.116c.675.009 1.118.113 1.318.31zm-9.28 3.284c.304-.137.766-.575 1.456-1.675a6.219 6.219 0 0 1-.237.218c-.66.54-1.106 1.15-1.219 1.457zm3.9-8.935c-.092 0-.083.71-.083.71 0 .373.054.941.167 1.302.136-.244.246-.573.237-1.042-.01-.47-.123-.97-.321-.97zm-1.107 6.34c.76-.293 1.623-.533 2.623-.73a4.906 4.906 0 0 1-.195-.156A5.433 5.433 0 0 1 7.534 8.28c-.168.436-.395.967-.754 1.645-.147.276-.29.538-.43.785zm6.252.018c.06-.038.056-.222-.299-.312s-.462-.089-.825-.089c-.198 0-.42.01-.66.027.627.269 1.075.434 1.437.434.112 0 .286-.022.347-.06z"
                                    fill="#6C6E79" />
                            </g>
                        </svg>
                    </a>
                    <a href="#" class="order-table__text order-table__text--inline order-table__text--icon">
                        <svg width="20" height="18" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd">
                                <path d="M17 5H3C1.34 5 0 6.34 0 8v6h4v4h12v-4h4V8c0-1.66-1.34-3-3-3zm-3 11H6v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H4v4h12V0z"
                                    fill="#6C6E79" fill-rule="nonzero" />
                                <path d="M-2-3h24v24H-2z" />
                            </g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <div class="order-table__row" (click)="clickOpenViewerPDF()">
            <div class="order-table__cell">
                <p class="order-table__cell-title">Fecha:</p>
                <div class="order-table__cell-content">
                    20/10/2017
                </div>
            </div>
            <div class="order-table__cell">
                <p class="order-table__cell-title">Nº factura:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">
                        <strong>F17-182</strong>
                    </p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg order-table__cell--2-0">
                <p class="order-table__cell-title">concepto:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg">
                <p class="order-table__cell-title">Nº pedido:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">
                        <strong>17-805</strong>
                    </p>
                    <p class="order-table__text">
                        IR17082798
                    </p>
                </div>
            </div>
            <div class="order-table__cell">
                <p class="order-table__cell-title">Estado:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text order-table__text--resolved">PAGADA</p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg">
                <p class="order-table__cell-title">Fecha vencimiento:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text">
                        24/08/2017
                    </p>
                </div>
            </div>
            <div class="order-table__cell  order-table__cell--center">
                <p class="order-table__cell-title">Importe:</p>
                <div class="order-table__cell-content">
                    <p class="order-table__text order-table__text--big">
                        <strong>1.450 &euro;</strong>
                    </p>
                </div>
            </div>
            <div class="order-table__cell order-table__cell--show-lg order-table__cell--center">
                <p class="order-table__cell-title">Opciones:</p>
                <div class="order-table__cell-content">
                    <a href="#" class="order-table__text order-table__text--inline order-table__text--icon">
                        <svg width="16" height="18" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd">
                                <rect stroke="#6C6E79" x=".5" y=".5" width="14.8" height="16.9" rx="3" />
                                <path d="M12.838 10.023c.071.07.137.17.148.253.035.277.009.548-.122.745a.521.521 0 0 1-.305.207 1.22 1.22 0 0 1-.306.034c-.674 0-1.742-.34-2.61-.827a23.17 23.17 0 0 0-3.58.85c-.988 1.723-1.706 2.493-2.324 2.493a.742.742 0 0 1-.335-.08l-.246-.125c-.154-.088-.177-.278-.146-.427.095-.466.67-1.054 1.538-1.572.102-.062.539-.292.557-.302l.255-.135c.246-.42.518-.918.818-1.504l.037-.073c.285-.557.607-1.19.865-1.817l.092-.223c-.36-1.374-.558-2.434-.366-3.143.064-.226.305-.377.605-.377l.155.005c.266-.011.435.2.521.398l.028.07c.022.066.03.09.041.174.084.608-.233 2.41-.233 2.41a7.513 7.513 0 0 1-.05.207c.292.803.762 1.532 1.326 2.058.21.195.476.358.735.507a10.93 10.93 0 0 1 1.584-.116c.675.009 1.118.113 1.318.31zm-9.28 3.284c.304-.137.766-.575 1.456-1.675a6.219 6.219 0 0 1-.237.218c-.66.54-1.106 1.15-1.219 1.457zm3.9-8.935c-.092 0-.083.71-.083.71 0 .373.054.941.167 1.302.136-.244.246-.573.237-1.042-.01-.47-.123-.97-.321-.97zm-1.107 6.34c.76-.293 1.623-.533 2.623-.73a4.906 4.906 0 0 1-.195-.156A5.433 5.433 0 0 1 7.534 8.28c-.168.436-.395.967-.754 1.645-.147.276-.29.538-.43.785zm6.252.018c.06-.038.056-.222-.299-.312s-.462-.089-.825-.089c-.198 0-.42.01-.66.027.627.269 1.075.434 1.437.434.112 0 .286-.022.347-.06z"
                                    fill="#6C6E79" />
                            </g>
                        </svg>
                    </a>
                    <a href="#" class="order-table__text order-table__text--inline order-table__text--icon">
                        <svg width="20" height="18" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd">
                                <path d="M17 5H3C1.34 5 0 6.34 0 8v6h4v4h12v-4h4V8c0-1.66-1.34-3-3-3zm-3 11H6v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H4v4h12V0z"
                                    fill="#6C6E79" fill-rule="nonzero" />
                                <path d="M-2-3h24v24H-2z" />
                            </g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>

